import { render, staticRenderFns } from "./serviceProviderChangeLog.vue?vue&type=template&id=a72a43fc&scoped=true"
import script from "./serviceProviderChangeLog.vue?vue&type=script&lang=js"
export * from "./serviceProviderChangeLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72a43fc",
  null
  
)

export default component.exports